<template>
  <div class="create-quote">
    <b-container>
      <b-row>
        <h1>Edit Quotation</h1>
      </b-row>
      <b-row>
        <b-button variant="primary" @click="export_quote()">Back</b-button>
      </b-row>
      <b-form
        @submit.prevent="update_quote">
        <!-- CUSTOMER INFORMATION -->
        <div id="customer-information">
          <b-row align-v="center">
            <b-col cols="3">
              <h3>Customer Info.</h3>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-name"
                label="Customer Name*"
                label-for="customer-name-input">
                <b-form-input id="customer-name-input"
                  v-model="editedQuote.customer_name"
                  required
                  trim></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="customer-phone"
                label="Customer Phone*"
                label-for="customer-phone-input">
                <b-form-input id="customer-phone-input" 
                  v-model="editedQuote.customer_phone"
                  required
                  trim></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-email"
                label="Customer Email"
                label-for="customer-email-input">
                <b-form-input id="customer-email-input" 
                  v-model="editedQuote.customer_email"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <label for="form_details.cemetery">Cemetery:</label>
              <b-form-select :disabled="(isProcessing) ? true : false" 
              v-model="editedQuote.customer_cemetery" 
              :options="cemeteryNames"></b-form-select>
            </b-col>
            <!-- <b-col>
              <b-form-group
                id="customer-cemetery"
                label="Cemetery"
                label-for="customer-cemetery-input">
                <b-form-input id="customer-cemetery-input" 
                  v-model="customer_cemetery"
                  trim></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-section"
                label="Section"
                label-for="customer-section-input">
                <b-form-input id="customer-section-input" 
                  v-model="editedQuote.customer_section"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <label for="funeral_provider">Funeral Provider:</label>
              <b-form-select id="funeral_provider" 
              :disabled="(isProcessing) ? true : false" 
              v-model="editedQuote.customer_funeral_provider" 
              :options="funeral_provider_names"></b-form-select>
            </b-col>
            <!-- <b-col>
              <b-form-group
                id="customer-funeral-provider"
                label="Funeral Provider*"
                label-for="customer-funeral-provider-input">
                <b-form-input id="customer-funeral-provider-input" 
                  v-model="customer_funeral_provider"
                  required
                  trim></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-row"
                label="Row"
                label-for="customer-row-input">
                <b-form-input id="customer-row-input" 
                  v-model="editedQuote.customer_row"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="customer-grave-number"
                label="Grave No."
                label-for="customer-grave-number-input">
                <b-form-input id="customer-grave-number-input" 
                  v-model="editedQuote.customer_grave_number"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-how-find"
                label="How did you find us?*"
                label-for="customer-how-find-input">
                <b-form-select 
                  :disabled="(isProcessing) ? true : false" 
                  v-model="editedQuote.customer_how_find" 
                  :options="lead_source_names"
                  required></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="customer-comment"
                label="Comment"
                label-for="customer-comment">
                <b-form-input id="customer-comment" 
                  v-model="editedQuote.customer_comment"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <!-- MONUMENT INFORMATION -->
        <b-row align-v="center" v-b-toggle.accordion-monument v-if="quotation_type == 'monument'">
          <b-col cols="3">
            <h3>Monument Info.</h3>
          </b-col>
          <b-col cols="8">
            <hr>
          </b-col>
          <b-col>
            <b-row>
              <b-icon
              icon="chevron-down"
              scale="1"
              variant="secondary"></b-icon>
            </b-row>
          </b-col>
        </b-row>
        <b-collapse visible id="accordion-monument" role="tabpanel" class="mx-3" v-if="quotation_type == 'monument'">
          <b-row>
            <b-col>
              <b-form-group
                id="monument-style"
                label="Monument Style"
                label-for="monument-style-select">
                <b-form-select id="monument-style-select"
                  v-model="editedQuote.monument_style" 
                  required
                  :options="monument_style_names"></b-form-select>
              </b-form-group>
              <!-- <b-form-group
                id="monument-style"
                label="Monument Type"
                label-for="monument-style-select">
                <b-form-select id="monument-style-select"
                  v-model="monument_style" 
                  required
                  :options="monument_style_names"></b-form-select>
              </b-form-group> -->
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group
                id="monument-type"
                label="Monument Type"
                label-for="monument-type-input">
                <b-form-input id="monument-type-input" 
                  v-model="editedQuote.monument_type"
                  trim></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-v="center">
            <b-col cols="3">
              <h3>Material Info.</h3>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
            <b-row>
              <b-col>
                <b-button variant="primary"
                  @click="add_material">Add a material</b-button>
              </b-col>
            </b-row>
            <b-row v-for="(material, index) in editedQuote.materials" :key="'material' + index"
              align-v="center">
              <b-col cols="4">
                <b-form-group
                  id="monument-material"
                  label="Monument Material"
                  label-for="monument-material-select">
                  <b-form-select :id="'monument-material-list-' + index"
                    v-model="editedQuote.materials[index].name" 
                    :options="material_name_options"
                    v-on:change="materials_changed(editedQuote.materials[index].name)"
                    required></b-form-select>
                  
                  <!-- <b-form-input :list="'monument-material-list-'+ index"
                    v-model="materials[index].name"
                    v-on:change="materials_changed">
                  </b-form-input>

                  <datalist :id="'monument-material-list-' + index">
                    <option v-for="(name, i) in material_name_options" :key="'material_name_option' + i">{{ name }}</option>
                  </datalist> -->

                  <!-- <b-form-select id="monument-material-select"
                    v-model="materials[index].name"
                    v-on:change="materials_changed"
                    :options="material_name_options"></b-form-select>  -->
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  id="monument-size"
                  label="Monument Size"
                  label-for="monument-size-select">
                  <b-form-select id="monument-size-select"
                    v-model="editedQuote.materials[index].size" 
                    :options="editedQuote.materials[index].sizes"
                    v-on:change="material_size_change(index)"
                    required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group
                  id="monument-usage"
                  label="Usage"
                  label-for="monument-usage-input">
                  <b-form-input id="monument-size-input"
                    type="number"
                    v-model="editedQuote.materials[index].usage"
                    step=".01"
                    required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-row>
                  <b-icon class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_material(index)"></b-icon>
                </b-row>
              </b-col>
            </b-row>
        </b-collapse>
        <!-- INSTALLATION INFORMATION -->
        <div id="installation-information" v-if="quotation_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-installation>
            <b-col cols="3">
              <h3>Installation</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-installation" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary"
                  @click="add_installation">
                Add an installation
                </b-button>
              </b-col>
            </b-row>
            <b-row v-for="(installation, index) in editedQuote.installations" :key="'installation' + index"
              align-v="center">
              <b-col cols="11">
                <b-form-group
                  id="installation-name"
                  label="Installation Name"
                  label-for="installation-name-select">
                  <b-form-select v-model="editedQuote.installations[index].name" 
                      :options="installation_name_options"
                      v-on:change="installations_change(editedQuote.installations[index].name)"
                      required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_installation(index)"></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- INSCRIPT INFORMATION -->
        <div id="inscript-information">
          <b-row align-v="center" v-b-toggle.accordion-inscript>
            <b-col cols="3">
              <h3>Inscription</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-inscript" role="tabpanel">
            <b-row>
              <b-col>
                <b-dropdown variant="primary" text="Add an inscription">
                  <div v-if="this.editedQuote.type == 'monument'">
                    <b-dropdown-item @click="add_inscription('arabic')">Arabic<b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('decoration')">Decoration<b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('english')">English<b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('chinese')">Chinese<b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                  </div>
                  <div v-if="this.editedQuote.type == 'inscription'">
                    <b-dropdown-item @click="add_inscription('Additional')"
                      >Additional Inscription<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="add_inscription('Crypt Shutters')"
                      >Crypt Shutters<b-icon
                        icon="plus"
                        scale="1.5"
                        variant="primary"
                      ></b-icon
                    ></b-dropdown-item>
                  </div>
                </b-dropdown>
              </b-col>
            </b-row>
            <b-row v-for="(inscription, index) in editedQuote.inscriptions" :key="'inscription' + index"
              align-v="center">
              <b-col cols="5">
                <b-form-group v-if="editedQuote.inscriptions[index].type == 'arabic'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_arabic_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>

                <b-form-group v-if="editedQuote.inscriptions[index].type == 'decoration'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_decoration_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>

                <b-form-group v-if="editedQuote.inscriptions[index].type == 'english'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_english_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>

                <b-form-group v-if="editedQuote.inscriptions[index].type == 'chinese'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_chinese_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>

                <b-form-group v-if="editedQuote.inscriptions[index].type == 'Additional'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_additional_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>

                <b-form-group v-if="editedQuote.inscriptions[index].type == 'Crypt Shutters'"
                  id="inscription-name"
                  label="Inscription Name"
                  label-for="inscription-name-select">

                  <b-form-select v-model="editedQuote.inscriptions[index].name" 
                    :options="inscription_crypt_shutters_name_options"
                    v-on:change="inscriptions_change(editedQuote.inscriptions[index].name)"
                    required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="5">
                <b-form-group
                  id="inscription-number"
                  label="Number"
                  label-for="inscription-number-input">
                  <b-form-input id="inscription-number-input" 
                    v-model="editedQuote.inscriptions[index].number"
                    type="number"
                    min="0"
                    required
                    trim></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-icon class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_inscription(index)"></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- ACCESSORY INFORMATION -->
        <div id="accessory-information" v-if="quotation_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-accessory>
            <b-col cols="3">
              <h3>Accessory</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-accessory" role="tabpanel">
            <b-row>
              <b-col>
                <b-dropdown variant="primary" text="Add an accessory">
                  <b-dropdown-item @click="add_door()">Door <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add_photo()">Photo <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add_others()">Others <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div>
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Doors</h3>
                </b-col>
                <b-col>
                  <hr>
                </b-col>
              </b-row>
              <b-row class="ml-2" v-for="(door, index) in editedQuote.accessory_doors" :key="'door' + index" align-v="center">
                <b-col cols="4">
                  <b-form-group
                    id="accessory-door-name"
                    label="Door Name"
                    label-for="accessory-door-name-select">

                    <b-form-select v-model="editedQuote.accessory_doors[index].name" 
                      :options="accessory_door_name_options"
                      v-on:change="accessory_doors_changed(editedQuote.accessory_doors[index].name)"
                      required></b-form-select>
                    <!-- <b-form-input :list="'accessory-door-name-list-'+ index"
                      v-model="accessory_doors[index].name"
                      v-on:change="accessory_doors_changed">
                    </b-form-input>

                    <b-form-input id="accessory-door-quantity-input"
                      v-model="accessory_door_quantity"
                      required
                      type="number"></b-form-input>

                    <datalist :id="'accessory-door-name-list-' + index">
                      <option v-for="(name, i) in accessory_door_name_options" :key="'accessory_door_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-door-size"
                    label="Door Size"
                    label-for="accessory-door-select">
                    <b-form-select id="accessory-door-select"
                      v-model="editedQuote.accessory_doors[index].size" 
                      :options="editedQuote.accessory_doors[index].sizes"
                      v-on:change="accessory_doors_size_changed(index)"
                      required></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-door-quantity"
                    label="Quantity"
                    label-for="accessory-door-quantity-input">
                    <b-form-input id="accessory-door-quantity-input"
                      v-model="editedQuote.accessory_doors[index].quantity"
                      required
                      type="number"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_door(index)"></b-icon>
                </b-col>
              </b-row>
              <!-- PHOTOS -->
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Photos</h3>
                </b-col>
                <b-col>
                  <hr>
                </b-col>
              </b-row>
              <b-row class="ml-2" v-for="(photo, index) in editedQuote.accessory_photos" :key="'photo' + index" align-v="center">
                <b-col cols="4">
                  <b-form-group
                    id="accessory-photo-name"
                    label="Photo Name"
                    label-for="accessory-photo-name-select">
                    <b-form-select v-model="editedQuote.accessory_photos[index].name" 
                      :options="accessory_photo_name_options"
                      v-on:change="accessory_photos_changed(editedQuote.accessory_photos[index].name)"
                      required></b-form-select>
                    <!-- <b-form-input :list="'accessory-photo-name-list-'+ index"
                      v-model="accessory_photos[index].name"
                      v-on:change="accessory_photos_changed">
                    </b-form-input>

                    <datalist :id="'accessory-photo-name-list-' + index">
                      <option v-for="(name, i) in accessory_photo_name_options" :key="'accessory_photo_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-photo-size"
                    label="Photo Size"
                    label-for="accessory-photo-select">
                    <b-form-select id="accessory-photo-select"
                      v-model="editedQuote.accessory_photos[index].size" 
                      :options="editedQuote.accessory_photos[index].sizes"
                      v-on:change="accessory_photos_size_changed(index)"
                      required></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-photo-quantity"
                    label="Quantity"
                    label-for="accessory-photo-quantity-input">
                    <b-form-input id="accessory-photo-quantity-input"
                      v-model="editedQuote.accessory_photos[index].quantity"
                      required
                      type="number"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_photo(index)"></b-icon>
                </b-col>
              </b-row>
              <!--Others -->
              <b-row align-v="center" class="mx-1">
                <b-col cols="3">
                  <h3>Others</h3>
                </b-col>
                <b-col>
                  <hr>
                </b-col>
              </b-row>
              <b-row class="ml-2" v-for="(others, index) in editedQuote.accessory_others" :key="'others' + index" align-v="center">
                <b-col cols="4">
                  <b-form-group
                    id="accessory-others-name"
                    label="Name"
                    label-for="accessory-others-name-select">
                    <b-form-select v-model="editedQuote.accessory_others[index].name" 
                      :options="accessory_others_name_options"
                      v-on:change="accessory_others_changed(editedQuote.accessory_others[index].name)"
                      required></b-form-select>
                    <!-- <b-form-input :list="'accessory-others-name-list-'+ index"
                      v-model="accessory_others[index].name"
                      v-on:change="accessory_others_changed">
                    </b-form-input>

                    <datalist :id="'accessory-others-name-list-' + index">
                      <option v-for="(name, i) in accessory_others_name_options" :key="'accessory_others_name_option' + i">{{ name }}</option>
                    </datalist> -->
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group
                    id="accessory-others-size"
                    label="Others Size"
                    label-for="accessory-others-select">
                    <b-form-select id="accessory-others-select"
                      v-model="editedQuote.accessory_others[index].size" 
                      :options="editedQuote.accessory_others[index].sizes"
                      v-on:change="accessory_others_size_changed(index)"
                      required></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group
                    id="accessory-others-quantity"
                    label="Quantity"
                    label-for="accessory-others-quantity-input">
                    <b-form-input id="accessory-others-quantity-input"
                      v-model="editedQuote.accessory_others[index].quantity"
                      required
                      type="number"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-icon class="ml-2"
                    icon="x-circle"
                    scale="1.5"
                    variant="primary"
                    @click="remove_others(index)"></b-icon>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </div>
        <!-- PERMIT INFORMATION -->
        <div id="permit-information" >
          <b-row align-v="center" v-b-toggle.accordion-permit>
            <b-col cols="3">
              <h3>Permit fee</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-permit" role="tabpanel">
            <b-row>
              <b-col>
                <b-form-group
                  id="permit-fee">
                  <b-form-input id="permit-fee-input" 
                    v-model="editedQuote.permit_fee"
                    type="number"
                    min="0"
                    trim></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- FOUNDATION INFORMATION -->
        <div id="foundation-information" v-if="quotation_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-foundation>
            <b-col cols="3">
              <h3>Foundation</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-foundation" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary"
                  @click="add_foundation">
                Add a foundation
                </b-button>
              </b-col>
            </b-row>
            <b-row v-for="(foundation, index) in editedQuote.foundations" :key="'foundation' + index"
              align-v="center">
              <b-col cols="11">
                <b-form-group
                  id="foundation-name"
                  label="Foundation Name"
                  label-for="foundation-name-select">
                  <b-form-select v-model="editedQuote.foundations[index].name" 
                      :options="foundation_name_options"
                      v-on:change="foundations_change(editedQuote.foundations[index].name)"
                      required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_foundation(index)"></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- Carving INFORMATION -->
        <div id="casting-information" v-if="quotation_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-casting>
            <b-col cols="3">
              <h3>Carving</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                    scale="1"
                    variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-casting" role="tabpanel">
            <b-row>
              <b-col>
                <b-button variant="primary"
                  @click="add_casting">
                Add a carving
                </b-button>
              </b-col>
            </b-row>
            <b-row v-for="(casting, index) in editedQuote.castings" :key="'casting' + index"
              align-v="center">
              <b-col cols="11">
                <b-form-group
                  id="casting-name"
                  label="Carving Name"
                  label-for="casting-name-select">
                  <b-form-select v-model="editedQuote.castings[index].name" 
                      :options="casting_name_options"
                      v-on:change="castings_change(editedQuote.castings[index].name)"
                      required></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="1">
                <b-icon class="ml-2"
                  icon="x-circle"
                  scale="1.5"
                  variant="primary"
                  @click="remove_casting(index)"></b-icon>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- EXTRA FEE INFORMATION -->
        <div id="extra-fee-information">
          <b-row align-v="center" v-b-toggle.accordion-information>
            <b-col cols="3">
              <h3>Extra Fee</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-information" role="tabpanel">
            <b-row>
              <b-col cols="2">
                <b-form-group
                  id="extra-fee"
                  label="Fee">
                  <b-form-input id="permit-fee-input" 
                    v-model="editedQuote.extra_fee"
                    type="number"
                    min="0"
                    trim></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="10">
                <b-form-group
                  id="extra-fee-description"
                  label="Description"
                  label-for="extra-fee-description">
                  <b-form-input id="extra-fee-description" 
                    v-model="editedQuote.extra_fee_description"
                    trim></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </div>
        <!-- DISOUNT INFORMATION -->
        <div id="discount-information" v-if="quotation_type == 'monument'">
          <b-row align-v="center" v-b-toggle.accordion-discount>
            <b-col cols="3">
              <h3>Material Discount</h3>
            </b-col>
            <b-col cols="8">
              <hr>
            </b-col>
            <b-col>
              <b-row>
                <b-icon icon="chevron-down"
                  scale="1"
                  variant="secondary"></b-icon>
              </b-row>
            </b-col>
          </b-row>
          <b-collapse visible id="accordion-discount" role="tabpanel">
            <b-row align-v="center">
              <b-col cols="11">
                <b-form-group
                  id="quote_discount">
                  <b-form-input id="quote_discount-input" 
                    v-model="editedQuote.quote_discount"
                    type="number"
                    min="0"
                    max="10"
                    trim>
                    </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="1">%</b-col>
            </b-row>
          </b-collapse>
        </div>
        <b-button type="submit" 
          variant="warning"
          block>Update</b-button>
        <b-button variant="primary" block @click="export_quote()">Back</b-button>
      </b-form>

      <b-modal size="lg"
        id="modal-update-quote"
        title="Update confirmation"
        hide-footer>
        <p>This operation will update a quote.</p>
        <div>
          <b-row>
            <b-col cols="10">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Customer Name: </strong>{{this.editedQuote.customer_name}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Customer Phone: </strong>{{this.editedQuote.customer_phone}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Cemetery: </strong>{{this.editedQuote.customer_cemetery}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Section: </strong>{{this.editedQuote.customer_section}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Grave No: </strong>{{this.editedQuote.customer_grave_number}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Funeral Provider: </strong>{{this.editedQuote.customer_funeral_provider}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Comment: </strong>{{this.editedQuote.customer_comment}}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="12">
                      <strong>Style: </strong>{{this.editedQuote.monument_style}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Sales: </strong>{{this.editedQuote.created_by_name}}
                    </b-col>
                    <b-col cols="12">
                      <strong>Created date: </strong>{{this.editedQuote.create_date}}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <br>
              <div>
                <div v-if="this.editedQuote.materials.length > 0" class="monument">
                  <b-row>
                    <b-col>
                      <strong>Monument</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>Price</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(material, index) in editedQuote.materials" :key="'material' + index">
                    <b-col>
                      <span v-if="editedQuote.monument_type != null">{{editedQuote.monument_type}} - </span>{{material.name}}<span> - {{material.size}} - {{material.usage}}</span>
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{material.total_price}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.quote_discount > 0" class="discount">
                  <b-row>
                    <b-col>
                      <strong>Materia Discount</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{this.editedQuote.quote_discount}}% off
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.permit_fee > 0" class="permit-fee">
                  <b-row>
                    <b-col>
                      <strong>Permit Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{this.editedQuote.permit_fee}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.inscriptions.length > 0" class="Inscription">
                  <b-row>
                    <b-col>
                      <strong>Inscription</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(inscription, index) in this.editedQuote.inscriptions" :key="'inscription' + index">
                    <b-col>
                      {{inscription.name}}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{inscription.price}} * {{inscription.number}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.accessories.length > 0" class="Accessory">
                  <b-row>
                    <b-col>
                      <strong>Accessory</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(accessory, index) in this.editedQuote.accessories" :key="'accessory' + index">
                    <b-col>
                      {{accessory.name}} - {{accessory.size}} * {{accessory.quantity}}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{accessory.total_price}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.castings.length > 0" class="Casting">
                  <b-row>
                    <b-col>
                      <strong>Carving</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(casting, index) in this.editedQuote.castings" :key="'casting' + index">
                    <b-col>
                      {{casting.name}}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{casting.price}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.installations.length > 0" class="Installation">
                  <b-row>
                    <b-col>
                      <strong>Installation</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(installation, index) in editedQuote.installations" :key="'installation' + index">
                    <b-col>
                      {{installation.name}}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{installation.price}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.foundations.length > 0" class="Foundation">
                  <b-row>
                    <b-col>
                      <strong>Foundation</strong>
                    </b-col>
                  </b-row>
                  <b-row v-for="(foundation, index) in editedQuote.foundations" :key="'foundation' + index">
                    <b-col>
                      {{foundation.name}}
                    </b-col>
                    <b-col class="text-right" cols="2">
                      {{foundation.price}}
                    </b-col>
                  </b-row>
                </div>
                <div v-if="this.editedQuote.extra_fee > 0" class="extra-fee">
                  <b-row>
                    <b-col>
                      <strong>Extra Fee</strong>
                    </b-col>
                    <b-col class="text-right">
                      {{this.editedQuote.extra_fee}}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      {{this.editedQuote.extra_fee_description}}
                    </b-col>
                  </b-row>
                </div>
                <br>
                <div class="total-price">
                  <b-row>
                    <b-col>
                      <strong>Total Price</strong>
                    </b-col>
                    <b-col class="text-right">
                      <strong>{{this.editedQuote.total_price}}</strong>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="modal-footer mt-1">
            <b-button variant="secondary" @click="hideModal('modal-update-quote')"> Cancel </b-button>
            <b-button :disabled="isUpdating" 
              variant="warning"
              @click="update_quote_task">
              <span v-if="!isUpdating">Update</span>
              <span v-if="isUpdating">
                <b-spinner small type="grow"></b-spinner>
                Updating...
              </span>
            </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app';

  export default ({
    created() {
      this.editedQuote = Object.assign({}, this.givenQuote);
      console.log(this.givenQuote)

      if (this.editedQuote.type != null) {
        this.quotation_type = this.editedQuote.type;
      }

      firebase.firestore().collection('lead_sources').orderBy('name').onSnapshot((collection) => {
        this.lead_sources = collection.docs.map(doc => doc.data());
        for (var i = 0; i < this.lead_sources.length; i++) {
          this.lead_source_names.push(this.lead_sources[i].name);
        }
      });

      firebase.firestore().collection('cemeteries').orderBy('name').onSnapshot((collection) => {
        this.cemeteries = collection.docs.map(doc => doc.data());
        for (var i = 0; i < this.cemeteries.length; i++) {
          this.cemeteryNames.push(this.cemeteries[i].name);
        }
      });

      firebase.firestore().collection('funeral_providers').orderBy('name').onSnapshot((collection) => {
        this.funeral_providers = collection.docs.map(doc => doc.data());
        for (var i = 0; i < this.funeral_providers.length; i++) {
          this.funeral_provider_names.push(this.funeral_providers[i].name);
        }
      });

      firebase.firestore().collection('job_styles').orderBy('name').onSnapshot((collection) => {
          this.monument_styles = collection.docs.map(doc => doc.data());
          for (var i = 0; i < this.monument_styles.length; i++) {
              this.monument_style_names.push(this.monument_styles[i].name);
          }
      });

      firebase.firestore().collection('monuments').orderBy('english_name').onSnapshot((collection) => {
        this.material_options = collection.docs.map(doc => doc.data());
        this.material_options.forEach((e) => {
          this.material_name_options.push(e.english_name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'Arabic').onSnapshot((collection) => {
        this.inscription_arabic_options = collection.docs.map(doc => doc.data());
        this.inscription_arabic_options.forEach((e) => {
          this.inscription_arabic_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'Decoration').onSnapshot((collection) => {
        this.inscription_decoration_options = collection.docs.map(doc => doc.data());
        this.inscription_decoration_options.forEach((e) => {
          this.inscription_decoration_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'English').onSnapshot((collection) => {
        this.inscription_english_options = collection.docs.map(doc => doc.data());
        this.inscription_english_options.forEach((e) => {
          this.inscription_english_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'Chinese').onSnapshot((collection) => {
        this.inscription_chinese_options = collection.docs.map(doc => doc.data());
        this.inscription_chinese_options.forEach((e) => {
          this.inscription_chinese_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'Additional').onSnapshot((collection) => {
        this.inscription_additional_options = collection.docs.map(doc => doc.data());
        this.inscription_additional_options.forEach((e) => {
          this.inscription_additional_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('inscriptions').orderBy('name').where('type', '==', 'Crypt Shutters').onSnapshot((collection) => {
        this.inscription_crypt_shutters_options = collection.docs.map(doc => doc.data());
        this.inscription_crypt_shutters_options.forEach((e) => {
          this.inscription_crypt_shutters_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('castings').orderBy('name').onSnapshot((collection) => {
        this.casting_options = collection.docs.map(doc => doc.data());
        this.casting_options.forEach((e) => {
          this.casting_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('installations').orderBy('name').onSnapshot((collection) => {
        this.installation_options = collection.docs.map(doc => doc.data());
        this.installation_options.forEach((e) => {
          this.installation_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('foundations').orderBy('name').onSnapshot((collection) => {
        this.foundation_options = collection.docs.map(doc => doc.data());
        this.foundation_options.forEach((e) => {
          this.foundation_name_options.push(e.name);
        });
      });

      firebase.firestore().collection('accessories').orderBy('name').onSnapshot((collection) => {
        this.accessory_options = collection.docs.map(doc => doc.data());
        this.accessory_options.forEach((e) => {
          switch (e.type) {
            case "door":
              this.accessory_door_options.push(e);
              this.accessory_door_name_options.push(e.name);
              break;
            case "photo":
              this.accessory_photo_options.push(e);
              this.accessory_photo_name_options.push(e.name);
              break;
            default:
              this.accessory_others_options.push(e);
              this.accessory_others_name_options.push(e.name);
              break;
          }
        });
      });

      firebase.firestore().collection('global_settings').onSnapshot((collection) => {
        const settings = collection.docs.map(doc => doc.data());
        if (settings.length > 0) {
          this.global_setting = settings[0];
          this.monument_discount = parseInt(this.global_setting.monument_discount);
        }
      });
    },
    computed: {
    },
    data() {
      return {
        quotation_type: "monument",
        quotes_with_same_customer_name: [],
        lead_sources: [],
        lead_source_names: [],
        funeral_providers: [],
        funeral_provider_names: [],
        global_setting: null,
        monument_discount: 100,
        customer_comment: "",
        customer_name: "",
        customer_phone: "",
        customer_email: "",
        customer_cemetery: "",
        customer_section: "",
        customer_funeral_provider: "",
        customer_row: "",
        customer_grave_number: "",
        customer_how_find: "",
        cemeteryNames: [],
        created_by_name: "",
        create_date: "",
        monument_style: "",
        monument_style_names: [],
        permit_fee: 0,
        materials: [],
        material_options: [],
        material_name_options: [],
        material_changed: false,
        inscriptions: [],
        inscription_options: [],
        inscription_name_options: [],

        inscription_arabic_options: [],
        inscription_arabic_name_options: [],

        inscription_decoration_options: [],
        inscription_decoration_name_options: [],

        inscription_english_options: [],
        inscription_english_name_options: [],

        inscription_chinese_options: [],
        inscription_chinese_name_options: [],

        inscription_additional_options: [],
        inscription_additional_name_options: [],

        inscription_crypt_shutters_options: [],
        inscription_crypt_shutters_name_options: [],

        castings: [],
        casting_options: [],
        casting_name_options: [],
        installations: [],
        installation_options: [],
        installation_name_options: [],
        accessories: [],
        accessory_options: [],
        accessory_doors: [],
        accessory_door_options: [],
        accessory_door_name_options: [],
        accessory_photos: [],
        accessory_photo_options: [],
        accessory_photo_name_options: [],
        accessory_others: [],
        accessory_others_options: [],
        accessory_others_name_options: [],
        foundations: [],
        foundation_options: [],
        foundation_name_options: [],
        extra_fee: 0,
        extra_fee_description: "",
        quote_discount: 0,
        total_price: 0,
        no_of_items: 0,
        quote_updated: false,
        newQuote: Object,
        updated_successfully: false,
        isProcessing: false,
        isUpdating: false,
        editedQuote: {},
      }
    },
    props: {
      givenQuote: Object,
      user: Object,
    },
    watch: {
    },
    methods: {
      back() {
        this.$emit("backTo", "Quotes");
      },
      add_material() {
        this.editedQuote.materials.push(
          {
            name: "",
            size: "",
            usage: "",
            price: 0,
            prices: [],
            sizes: [],
            total_price: 0,
          }
        );
      },
      add_inscription(type) {
        this.editedQuote.inscriptions.push(
          {
            type: type,
            name: "",
            number: 1,
            price: 0,
          }
        );
      },
      add_casting() {
        this.editedQuote.castings.push(
          {
            name: "",
            price: 0,
          }
        );
      },
      add_installation() {
        this.editedQuote.installations.push(
          {
            name: "",
            price: 0,
          }
        );
      },
      add_foundation() {
        this.editedQuote.foundations.push(
          {
            name: "",
            price: 0,
          }
        );
      },
      add_door() {
        this.editedQuote.accessory_doors.push(
          {
            name: "",
            size: "",
            price: "",
            sizes: [],
            prices: [],
            quantity: 1,
            total_price: 0,
          }
        )
      },
      add_photo() {
        this.editedQuote.accessory_photos.push(
          {
            name: "",
            size: "",
            price: "",
            prices: [],
            sizes: [],
            quantity: 1,
            total_price: 0,
          }
        )
      },
      add_others() {
        this.editedQuote.accessory_others.push(
          {
            name: "",
            size: "",
            price: "",
            prices: [],
            sizes: [],
            quantity: 1,
            total_price: 0,
          }
        )
      },
      materials_changed(oldName) {
        var index = 0;
        this.editedQuote.materials.forEach((e) => {
          if (e.name.length > 0 && e.name == oldName) {
            index = this.material_name_options.indexOf(e.name);

            e.size = "";
            e.sizes = [];
            e.prices = [],
            this.material_options[index].priceAndSize.forEach((p) => {
              e.sizes.push(p.size);
              e.prices.push(p.price);
            });
          }
        });
      },
      material_size_change(index) {
        const m = this.editedQuote.materials[index];
        if (m.size != null) { 
          m.price = m.prices[m.sizes.indexOf(m.size)];
        }
      },
      inscriptions_change(name) {
        this.editedQuote.inscriptions.forEach((e) => {
          if (e.name == name) {
            if (e.type == 'arabic') {
              e.price = this.inscription_arabic_options[this.inscription_arabic_name_options.indexOf(e.name)].price;
            }
            if (e.type == 'decoration') {
              e.price = this.inscription_decoration_options[this.inscription_decoration_name_options.indexOf(e.name)].price;
            }
            if (e.type == 'english') {
              e.price = this.inscription_english_options[this.inscription_english_name_options.indexOf(e.name)].price;
            }
            if (e.type == 'chinese') {
              e.price = this.inscription_chinese_options[this.inscription_chinese_name_options.indexOf(e.name)].price;
            }
            if (e.type == 'Additional') {
              e.price = this.inscription_additional_options[this.inscription_additional_name_options.indexOf(e.name)].price;
            }
            if (e.type == 'Crypt Shutters') {
              e.price = this.inscription_crypt_shutters_options[this.inscription_crypt_shutters_name_options.indexOf(e.name)].price;
            }
          }
        });
      },
      accessory_doors_changed(name) {
        var index = 0;
        this.editedQuote.accessory_doors.forEach((e) => {
          if (e.name.length > 0 && e.name == name) {
            index = this.accessory_door_name_options.indexOf(e.name);

            e.size = "";
            e.prices = [];
            e.sizes = [];
            this.accessory_door_options[index].specAndPrice.forEach((p) => {
              e.sizes.push(p.spec);
              e.prices.push(p.price);
            });
          }
        });
      },
      accessory_doors_size_changed(index) {
        const d = this.editedQuote.accessory_doors[index];
        console.log(d.size);
        if (d.size != null) {
          d.price = d.prices[d.sizes.indexOf(d.size)];
          //alert(d.price);
        }
      },
      accessory_photos_changed(name) {
        var index = 0;
        this.editedQuote.accessory_photos.forEach((e) => {
          if (e.name.length > 0 && e.name == name) {
            index = this.accessory_photo_name_options.indexOf(e.name);

            e.size = "";
            e.prices = [];
            e.sizes = [];
            this.accessory_photo_options[index].specAndPrice.forEach((p) => {
              e.sizes.push(p.spec);
              e.prices.push(p.price);
            });
          }
        });
      },
      accessory_photos_size_changed(index) {
        const p = this.editedQuote.accessory_photos[index];
        if (p.size != null) {
          p.price = p.prices[p.sizes.indexOf(p.size)];
          //alert(p.price);
        }
      },
      accessory_others_changed(name) {
        var index = 0;
        this.editedQuote.accessory_others.forEach((e) => {
          if (e.name.length > 0 && e.name == name) {
            index = this.accessory_others_name_options.indexOf(e.name);

            e.size = "";
            e.sizes = [];
            e.prices = [];
            this.accessory_others_options[index].specAndPrice.forEach((p) => {
              e.sizes.push(p.spec);
              e.prices.push(p.price);
            });
          }
        });
      },
      accessory_others_size_changed(index) {
        const o = this.editedQuote.accessory_others[index];
        if (o.size != null) {
          o.price = o.prices[o.sizes.indexOf(o.size)];
          //alert(o.price);
        }
      },
      castings_change(name) {
        this.editedQuote.castings.forEach((e) => {
          if (e.name == name) {
            e.price = this.casting_options[this.casting_name_options.indexOf(e.name)].price;
            //alert(e.price);
          }
        });
      },
      installations_change(name) {
        this.editedQuote.installations.forEach((e) => {
          if (e.name == name) {
            e.price = this.installation_options[this.installation_name_options.indexOf(e.name)].price;
            //alert(e.price);
          }
        });
      },
      foundations_change(name) {
        this.editedQuote.foundations.forEach((e) => {
          if (e.name == name) {
            e.price = this.foundation_options[this.foundation_name_options.indexOf(e.name)].price;
            //alert(e.price);
          }
        });
      },
      remove_material(index) {
        this.editedQuote.materials.splice(index, 1);
      },
      remove_inscription(index) {
        this.editedQuote.inscriptions.splice(index, 1);
      },
      remove_foundation(index) {
        this.editedQuote.foundations.splice(index, 1);
      },
      remove_casting(index) {
        this.editedQuote.castings.splice(index, 1);
      },
      remove_installation(index) {
        this.editedQuote.installations.splice(index, 1);
      },
      remove_door(index) {
        this.editedQuote.accessory_doors.splice(index, 1);
      },
      remove_photo(index) {
        this.editedQuote.accessory_photos.splice(index, 1);
      },
      remove_others(index) {
        this.editedQuote.accessory_others.splice(index, 1);
      },
      hideModal(id) {
        this.$bvModal.hide(id);
      },
      showModal(id) {
        this.$bvModal.show(id);
      },
      update_quote() {
        this.calculate_price();

        if (this.no_of_items < 3 && this.quotation_type == "monument") {
          alert("A monument quote must include at least 3 items!");
          return;
        } else if (this.no_of_items < 2 && this.quotation_type == "inscription") {
          alert("A inscription quote must include at least 2 items!");
          return;
        }

        this.created_by_name = this.user.name;
        // this.create_date = this.today;

        this.editedQuote.accessories = [];
        this.editedQuote.accessory_doors.forEach((e) => {
          this.editedQuote.accessories.push(e);
        });
        this.editedQuote.accessory_photos.forEach((e) => {
          this.editedQuote.accessories.push(e);
        });
        this.editedQuote.accessory_others.forEach((e) => {
          this.editedQuote.accessories.push(e);
        });

        this.showModal('modal-update-quote');
      },
      update_quote_task() {
        this.isUpdating = true;
        const quote_ref = firebase.firestore().collection("quotes").doc(this.editedQuote.id);

        quote_ref.set(this.editedQuote, {merge: true}).then(() => {
          this.updated_successfully = true;
          this.quote_updated = true;
          this.isUpdating = false;
          this.hideModal('modal-update-quote');
        });
      },
      calculate_price() {
        var contain_accessory = false;
        this.total_price = 0.0;
        this.no_of_items = 0;
        this.editedQuote.total_price = 0;

        if (this.editedQuote.materials.length > 0) {
          this.editedQuote.materials.forEach((m) => {
            this.no_of_items += 1;
            console.log(m.price + ' ' + m.usage + ' ' + this.monument_discount + '% ' + this.editedQuote.quote_discount);
            m.total_price = 
            Math.round(
              parseInt(m.price) * 
              parseFloat(m.usage) * 
              (this.monument_discount*1.0 / 100) * 
              (1 - this.editedQuote.quote_discount * 1.0 / 100)
            ).toFixed(2);
            // console.log(m.price);
            if (m.name.length == 0 || m.price.length == 0 || m.usage.length == 0) {
              alert("The size, name and usage of materials must be determined!!");
              return;
            } else {
              this.editedQuote.total_price += parseFloat(m.total_price);
            }
          });
        }

        // if (this.editedQuote.quote_discount != null && this.editedQuote.quote_discount > 0) {
        //   this.editedQuote.total_price = this.editedQuote.total_price * ((100 - parseInt(this.editedQuote.quote_discount)) / 100);
        // }

        if (this.editedQuote.permit_fee != null && this.editedQuote.permit_fee > 0) {
          this.no_of_items += 1;
          this.editedQuote.total_price += parseFloat(this.editedQuote.permit_fee);
        }

        if (this.editedQuote.inscriptions.length > 0) {
          this.editedQuote.inscriptions.forEach((i) => {
            this.no_of_items += 1;
            if (i.name.length == 0 || i.number == 0) {
              alert("The number and name of inscriptions must be determined!!");
              return;
            } else {
              this.editedQuote.total_price += parseFloat(i.price) * parseFloat(i.number);
            }
          });
        }

        //console.log(this.editedQuote.total_price)

        if (this.editedQuote.accessory_doors.length > 0) {
          if (!contain_accessory) {
            contain_accessory = true;
          }
          this.editedQuote.accessory_doors.forEach((d) => {
            this.no_of_items += 1;
            if (d.name.length == 0 || d.size.length == 0) {
              alert("The size and name of doors must be determined!!");
              return false;
            } else {
              d.total_price = parseFloat(d.price) * parseInt(d.quantity)
              this.editedQuote.total_price += d.total_price;
            }
          });
          // console.log(this.total_price);
        }

        if (this.editedQuote.accessory_photos.length > 0) {
          if (!contain_accessory) {
            contain_accessory = true;
          }
          this.editedQuote.accessory_photos.forEach((p) => {
            this.no_of_items += 1;
            if (p.name.length == 0 || p.size.length == 0) {
              alert("The size and name of photos must be determined!!");
              return;
            } else {
              p.total_price = parseFloat(p.price) * parseInt(p.quantity);
              this.editedQuote.total_price += p.total_price;
            }
          });
          // console.log(this.total_price);
        }

        if (this.editedQuote.accessory_others.length > 0) {
          if (!contain_accessory) {
            contain_accessory = true;
          }
          this.editedQuote.accessory_others.forEach((o) => {
            this.no_of_items += 1;
            if (o.name.length == 0 || o.size.length == 0) {
              alert("The size and name of other accessories must be determined!!");
              return;
            } else {
              o.total_price = parseFloat(o.price) * parseInt(o.quantity);
              this.editedQuote.total_price += o.total_price;
            }
          });
          // console.log(this.total_price);
        }

        if (this.editedQuote.castings.length > 0) {
          this.editedQuote.castings.forEach((c) => {
            this.no_of_items += 1;
            if (c.name.length == 0) {
              alert("The name of casting must be determined");
              return;
            } else {
              this.editedQuote.total_price += parseFloat(c.price);
            }
          });
          // console.log(this.total_price);
        }

        // console.log(this.total_price);

        if (this.editedQuote.installations.length > 0) {
          this.editedQuote.installations.forEach((i) => {
            this.no_of_items += 1;
            if (i.name.length == 0) {
              alert("The name of installation must be determined");
              return;
            } else {
              this.editedQuote.total_price += parseFloat(i.price);
            }
          });
          // console.log(this.total_price);
        }

        if (this.editedQuote.foundations.length > 0) {
          this.editedQuote.foundations.forEach((f) => {
            this.no_of_items += 1;
            if (f.name.length == 0) {
              alert("The name of casting must be determined");
              return;
            } else {
              this.editedQuote.total_price += parseFloat(f.price);
            }
          });
          // console.log(this.total_price);
        }

        if (this.editedQuote.extra_fee != null && this.editedQuote.extra_fee > 0) {
          this.editedQuote.total_price += parseFloat(this.editedQuote.extra_fee);
        }
        this.editedQuote.total_price = this.editedQuote.total_price.toFixed(2);
      },
      export_quote() {
        this.$emit('viewQuote', {quote: this.editedQuote, from: 'Quotes'});
      },
      continueToCreate() {
        this.hideModal('modal-same-customer-alert');
        this.showModal('modal-update-quote');
      }
    },
  })
</script>
